import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { RequestBodyCompany } from '../../core/models/request-body.model';
import { CompanyIntentPayloadInterface, CompanyIntentResponseInterface } from '../../shared/dto/company-intent.dto';
import { BaseApiService, CompaniesApiService } from '../../shared/services/api';

@Injectable({
    providedIn: 'root'
})
export class CompanyDetailService {
    searchCriteria: RequestBodyCompany;
    searchURL: string = 'service/contactcloud/companies/';
    searchUniversalUrl: string = 'service/contactcloud/universal/';
    resultPage = {
        IsNavigating: false,
        resultData: [],
        totalHumanVerifiedCount: 0,
        totalPendingVerifiedCount: 0,
        companySidebarData: null,
        contactsSortedBy: '',
        contactsSortedByDirection: ''
    };
    companyInternational = new BehaviorSubject(0);
    isCompanyInternational = 0;

    constructor(
        private readonly companiesApiService: CompaniesApiService,
        private readonly baseApiService: BaseApiService,
    ) {
        this.companyInternational.subscribe((internationData) => this.isCompanyInternational = internationData);
    }


    getCompanyDetail(data): Observable<any> {
        return this.baseApiService.post(this.searchUniversalUrl + 'search', data, { showError: true });
    }

    getExecutives(params): Observable<any> {
        return this.baseApiService.get(this.searchURL + 'executives', {
            params: {
                ...params,
                ...(this.isCompanyInternational !== null ? { is_international: this.isCompanyInternational } : {})
            }
        });
    }

    getCompetitors(company_ids: any): Observable<any> {
        return this.companiesApiService.getCompetitors(company_ids);
    }

    getCompIdsForCompetitors(data): Observable<any> {
        data.is_international = this.isCompanyInternational;
        return this.baseApiService.post(this.searchUniversalUrl + 'companyIds', data, { showError: true });
    }

    getContactMatrix(params): Observable<any> {
        return this.baseApiService.get(this.searchURL + 'contactMatrix', {
            params: {
                ...params,
                ...(this.isCompanyInternational !== null ? { is_international: this.isCompanyInternational } : {})
            }
        });
    }

    getCompanyIntent(data: CompanyIntentPayloadInterface): Observable<CompanyIntentResponseInterface> {
        return this.companiesApiService.getIntents(data);
    }

    requestVerifyCompany(requestBody): Observable<any> {
        return this.baseApiService.post('service/contactcloud/research/requestResearchCompany', requestBody, { showError: true });
    }

    requestVerifyCompanyInboxintel(requestBody): Observable<any> {
        return this.baseApiService.post('service/contactcloud/research/requestResearchCompaniesV2', requestBody, { showError: true });
    }
}
